import {useEffect, useState} from 'react';

/**
 * Use this instead of Date.now() in render.
 *
 * https://react.dev/reference/rules/components-and-hooks-must-be-pure#components-and-hooks-must-be-idempotent
 */
export const useDateNow = (): number => {
  const [time, setTime] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => {
      setTime(Date.now());
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return time;
};
